exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".px-2 {\n  padding-left: 1rem;\n  padding-right: 1rem; }\n\n.py-2 {\n  padding-top: 1rem;\n  padding-bottom: 1rem; }\n\n.mb-2 {\n  margin-bottom: 1rem !important; }\n\n.has-fields .info-field {\n  width: 100%; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/complex/ProductWarehouseScanner/index.scss
// module id = 6999
// module chunks = 0